

import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { gastoXID, listadoGastosTodos, recalcularGastosCaja } from "../../../services";
import { useSearchParams } from "react-router-dom";




export const useGastoXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['gasto-id', { id }], 
        queryFn: () => gastoXID(id),
        enabled: !!id,
    });
    return { data, isLoading }
}





export const useListGastosTodos = () => {
    
    const [searchParams, setSearchParams] = useSearchParams();
    const page = parseInt(searchParams.get('page') || '0');
    const inicio = searchParams.get('inicio') || '';
    const final = searchParams.get('final') || '';

    const { data, isLoading } = useQuery({
        queryKey: ['todos-gastos', { page, inicio, final }], 
        queryFn: () => listadoGastosTodos({ page, inicio, final }),
    });


    const totalesGastosCaja = useQuery({
        queryKey: ['gastos-caja-totales', inicio, final],
        queryFn: () => recalcularGastosCaja({ inicio, final }),
    });


    const chagePage = useCallback((num) => {
        setSearchParams(prev => {
            prev.set('page', (num - 1).toString());
            return prev;
        }, { replace: true });
    }, [setSearchParams]);



    const chageInicio = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('inicio', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);



    const chageFinal = useCallback((valor) => {
        setSearchParams(prev => {
            prev.set('final', valor);
            prev.set('page', '0');
            return prev;
        }, { replace: true });
    }, [setSearchParams]);



    return {
        // Estados
        page,
        inicio,
        final,
        // Métodos
        chagePage,
        chageInicio,
        chageFinal,
        // Data
        data, isLoading,
        totalesGastosCaja,
    }
}
